module.exports = __webpack_public_path__ + "static/media/icon_info_red.0bc98d3c.svg";